import { render, staticRenderFns } from "./CreateEditProduct.vue?vue&type=template&id=b089951a&scoped=true"
import script from "./CreateEditProduct.vue?vue&type=script&lang=js"
export * from "./CreateEditProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateEditProduct.vue?vue&type=style&index=0&id=b089951a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b089951a",
  null
  
)

export default component.exports